import React from 'react';
import { motion } from 'framer-motion';
export function AboutLorena() {
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-15">
      <div className="max-w-6xl mx-auto px-6" data-id="element-16">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-17">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="w-full lg:w-1/2 relative" data-id="element-18">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] max-w-md mx-auto lg:mx-0" data-id="element-19">
              <img src="https://cdn.magicpatterns.com/uploads/1ydU3pBZDVpwLQa71qNqCH/5e5db8e9-809f-44a9-84ed-e389f3cedb79.jpg" alt="Lorena Pérez" className="w-full h-full object-cover" data-id="element-20" />
            </div>
            {/* Decorative background element */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-gold rounded-2xl z-0 max-w-md mx-auto lg:mx-0" data-id="element-21"></div>
          </motion.div>

          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="w-full lg:w-1/2" data-id="element-22">
            <h2 className="font-serif text-4xl md:text-5xl mb-6 text-[#0D1B3E]" data-id="element-23">
              Hola, soy Lorena
            </h2>
            <div className="w-16 h-1 bg-gold mb-8" data-id="element-24"></div>

            <div className="space-y-6 text-navy/80 text-lg leading-relaxed font-light" data-id="element-25">
              <p data-id="element-26">
                Durante años viví atrapada en el ciclo de empezar una nueva
                dieta cada lunes. Conocía la teoría, sabía qué "debía" comer,
                pero mi cuerpo y mi mente estaban agotados de tanta restricción
                y culpa.
              </p>
              <p data-id="element-27">
                Me di cuenta de que el problema no era mi fuerza de voluntad,
                sino el enfoque. Estaba intentando encajar mi vida en un molde
                rígido, en lugar de crear un sistema que se adaptara a mi
                realidad como mujer ocupada.
              </p>
              <p data-id="element-28">
                Tras certificarme en nutrición integral y coaching de bienestar,
                desarrollé el Método RenuevaTE_90. Un sistema probado que
                integra cuerpo, mente y espíritu para lograr resultados reales
                que perduran en el tiempo, sin sacrificar tu paz mental.
              </p>
            </div>

            <div className="mt-10 p-6 bg-navy/5 border-l-4 border-gold rounded-r-xl" data-id="element-29">
              <p className="font-serif text-xl italic text-[#0D1B3E]" data-id="element-30">
                "Saludable sin ser Esclavo no es un slogan. Es mi filosofía de
                vida y la tuya también puede serlo."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}